import { Target, Eye } from "lucide-react";
import { Reveal, SectionHeading } from "../Reveal";

export const About = () => (
  <section id="about" data-testid="about-section" className="py-24 lg:py-32 bg-white overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal className="relative">
          <div className="absolute -top-6 -left-6 w-40 h-40 rounded-3xl bg-brand-mist -z-0" />
          <div className="relative rounded-[2rem] overflow-hidden shadow-[0_24px_60px_rgb(11,27,61,0.14)]">
            <img
              src="https://images.pexels.com/photos/7545219/pexels-photo-7545219.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200"
              alt="Caregiver sharing a warm moment with an elderly couple in their home"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-8 -right-4 sm:right-8 bg-brand-navy text-white rounded-2xl px-7 py-5 shadow-[0_16px_40px_rgb(11,27,61,0.35)]">
            <p className="font-display italic text-2xl text-brand-cyan">24/7</p>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] mt-1 text-slate-300">Care & Support</p>
          </div>
        </Reveal>

        <div>
          <SectionHeading title="Care that feels Personal" />
          <Reveal delay={0.15}>
            <div className="mt-6 space-y-5 text-lg leading-relaxed text-slate-600">
              <p>
                BMS Health Care Services provides high-quality, personalized healthcare and support services to patients and families across Surrey and the Lower Mainland. We are dedicated to compassionate, professional, and individualized care that respects privacy, dignity, independence, and quality of life.
              </p>
              <p>
                From a few hours of companionship each week to round-the-clock support, our team works closely with every client and family to deliver care that feels personal, dependable, and genuinely warm. At BMS, care is not just a service — it is a relationship built on trust.
              </p>
            </div>
          </Reveal>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5">
            <Reveal delay={0.2}>
              <div data-testid="mission-card" className="h-full rounded-2xl border border-slate-200 bg-brand-paper p-7 hover:border-brand-teal/50 hover:shadow-[0_16px_40px_rgb(0,128,128,0.10)] transition-colors duration-300">
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-brand-teal/10 text-brand-teal">
                  <Target className="h-5 w-5" strokeWidth={1.6} />
                </div>
                <h3 className="mt-4 font-display text-xl text-brand-navy">Our Mission</h3>
                <p className="mt-3 text-base leading-relaxed text-slate-600">
                  To provide compassionate, professional, and personalized healthcare services that empower patients and families to achieve the highest possible quality of life through dignity, respect, and excellence in care.
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.3}>
              <div data-testid="vision-card" className="h-full rounded-2xl border border-slate-200 bg-brand-paper p-7 hover:border-brand-teal/50 hover:shadow-[0_16px_40px_rgb(0,128,128,0.10)] transition-colors duration-300">
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-brand-teal/10 text-brand-teal">
                  <Eye className="h-5 w-5" strokeWidth={1.6} />
                </div>
                <h3 className="mt-4 font-display text-xl text-brand-navy">Our Vision</h3>
                <p className="mt-3 text-base leading-relaxed text-slate-600">
                  To become a trusted provider of home and community healthcare services by delivering exceptional care, promoting independence, and improving the well-being of every individual served.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </div>
  </section>
);
